
function getQueryString(search) {
  const params = Object.keys(search)
    .filter((key) => search[key] !== "")
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(search[key])}`
    )
    .join("&");
  return '?' + params;
}

export {
  getQueryString,
};
